import Phaser from 'phaser';
import { NEON_PALETTE } from '@/utils/ColorUtils';

const RAVER_WIDTH = 12;
const RAVER_HEIGHT = 18;

/** Generate tiny isometric raver sprites with different color outfits */
export function generateRaverTextures(scene: Phaser.Scene): void {
  for (let i = 0; i < NEON_PALETTE.length; i++) {
    const key = `raver-${i}`;
    if (scene.textures.exists(key)) continue;

    const color = NEON_PALETTE[i];
    const hex = '#' + color.toString(16).padStart(6, '0');

    const canvas = scene.textures.createCanvas(key, RAVER_WIDTH, RAVER_HEIGHT)!;
    const ctx = canvas.context;

    // Head
    ctx.fillStyle = '#ffcc88';
    ctx.beginPath();
    ctx.arc(RAVER_WIDTH / 2, 4, 3, 0, Math.PI * 2);
    ctx.fill();

    // Body (neon shirt)
    ctx.fillStyle = hex;
    ctx.fillRect(RAVER_WIDTH / 2 - 3, 7, 6, 6);

    // Legs
    ctx.fillStyle = '#222222';
    ctx.fillRect(RAVER_WIDTH / 2 - 3, 13, 2, 4);
    ctx.fillRect(RAVER_WIDTH / 2 + 1, 13, 2, 4);

    canvas.refresh();
  }
}
